export default __webpack_public_path__ + "static/solidringtube-cc4c4b9dd072c4b5468e3b91aba490bc.png";